import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { Any } from 'json2typescript';

@JsonObject('model.vacationDay')
export class VacationDay extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Boolean, 'approved')
  approved?: boolean;

  @JsonProperty(Boolean, 'rejected')
  rejected?: boolean;

  @JsonProperty(String, 'rejectReason')
  rejectReason?: string;

  @JsonProperty(String, 'type')
  type?: string;

  @JsonProperty(String, 'startTime')
  startTime?: string;

  @JsonProperty(User, 'user')
  user?: User;

}
